import { render, staticRenderFns } from "./InfoMedewerker.vue?vue&type=template&id=0ab77a7d&scoped=true&"
import script from "./InfoMedewerker.vue?vue&type=script&lang=js&"
export * from "./InfoMedewerker.vue?vue&type=script&lang=js&"
import style0 from "./InfoMedewerker.vue?vue&type=style&index=0&id=0ab77a7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab77a7d",
  null
  
)

export default component.exports